//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import API from "~/api/api";
import FormField from "@/models/FormField";
import Contact from "@/models/Contact";
import aos from "~/mixins/aos.js";

export default {
  layout: "default-no-sticky",
  watch: {},
  mixins: [aos],
  data() {
    return {
      submission: {
        from: "",
        phone_number: "",
        name: "",
        subject: "",
        body: "",
      },
      showVideo: false,
      submitted: false,
      fields: [
        new FormField({
          field_type: "text",
          name: "name",
          label: "Your name",
          placeholder: "",
          validation: { required: true },
          width: 6,
          meta: { autocomplete: "name" },
        }),
        new FormField({
          field_type: "select",
          name: "subject",
          label: "Select Subject",
          placeholder: "Select Subject",
          options: [
            {
              label: "Documents",
              value: "Documents",
            },
            {
              label: "Business Formation",
              value: "Business-Formation",
            },
            {
              label: "Other",
              value: "Other",
            },
          ],

          validation: { required: true },
          width: 6,
        }),
        new FormField({
          field_type: "text",
          name: "from",
          label: "Email",
          placeholder: "",
          validation: { required: true },
          width: 6,
          meta: { autocomplete: "email" },
        }),
        new FormField({
          field_type: "phone_number",
          name: "phone_number",
          label: "Phone Number",
          placeholder: "",
          validation: { required: false },
          width: 6,
          meta: { autocomplete: "phone" },
        }),
        new FormField({
          field_type: "textarea",
          name: "body",
          label: "Message",
          placeholder: "",
          validation: { required: false },
          width: 12,
          meta: { autocomplete: "phone" },
        }),
      ],
    };
  },
  methods: {
    handleSubmit() {
      Contact.createWithApi(this.submission)
        .then((_) => {
          this.submitted = true;
        })
        .catch((e) => console.error(e.message));
    },
    updateData(newValue) {
      this.submission = newValue;
      this.error = null;
    },
  },

  head() {
    if (this.pageInfo) {
      let domain = "https://www.legalnature.com";
      let canonicalLink = domain + "/contact";
      let meta = [
        { name: "description", content: this.metaInfo.description },
        { name: "keyword", content: this.metaInfo.keyword },
        { name: "og:image", content: this.metaInfo["og-image"] },
        { name: "og:title", content: this.metaInfo.title },
        { name: "og:description", content: this.metaInfo.description },
        { name: "og:type", content: "website" },
        { name: "og:url", content: canonicalLink },
      ];
      return {
        title: this.metaInfo.title,
        meta,
        link: [
          {
            rel: "canonical",
            href: canonicalLink,
          },
        ],
      };
    } else {
      return {};
    }
  },

  asyncData({ app, query, params, redirect, error }) {
    return Promise.all([
      API.butterPages.get(app.$axios, "contact", {
        preview: query.preview ? 1 : 0,
      }),
    ])
      .then((results) => {
        const pageInfo = results[0];

        return {
          pageInfo,
          loading: false,
          error: false,
        };
      })
      .catch((e) => {
        console.error(e);
        error({ message: "Error fetching data..." });

        return {
          loading: false,
        };
      });
  },
  computed: {
    hero() {
      return this.pageInfo.fields.hero.table;
    },
    customer_support() {
      return this.pageInfo.fields.customer_support.table;
    },
    help_center() {
      return this.pageInfo.fields.help_center.table;
    },
    offices() {
      return this.pageInfo.fields.offices.table;
    },
    two_items_cta() {
      return this.pageInfo.fields.two_items_cta.table;
    },
    about_section() {
      return this.pageInfo.fields.about_section.table;
    },
    metaInfo() {
      return this.pageInfo.fields.meta_information.table;
    },
  },
};
